import React from 'react';
import { Typography, Grid } from '@mui/material';
import clsx from 'clsx';
import { Icons } from 'components';
import { useStyles } from './style';

const Empty = ({
  label = 'موردی یافت نشد!',
  img,
  gray = false,
  className,
  imageClassName,
  ...rest
}) => {
  const classes = useStyles();
  return (
    <Grid
      className={clsx(classes.root, className)}
      container
      justifyContent="center"
      alignItems="center"
      alignContent="center"
      direction="column"
      {...rest}
    >

      <div className={classes.icon}>
        <Icons icon="FolderError" color="#303d8f" size="45" />
      </div>
      <Typography className={gray ? classes.labelGray : classes.label}>{label}</Typography>
    </Grid>
  );
};

export default Empty;
